<template>
    <ContainerWithMenu>
        <div class="page-content">
            <div class="row margin-bottom-20">
                <div class="col-xs-12 col-md-5">
                    <h1 class="h2 margin-0">{{ $t('views.rates.title') }}</h1>
                </div>
                <div class="col-xs-12 col-md-7 text-right">
                    <button
                            class="btn btn-primary btn-action-mobile"
                            @click="showAddRateModal"
                    >
                        <i class="las la-plus"></i>
                        <span class="button-text">{{ $t('views.rates.new') }}</span>
                    </button>
                </div>
            </div>
            <Pagination
                    v-show="numberPagesRates > 1"
                    :page-count="numberPagesRates"
                    :click-handler="paginateCallback" />
            <RateTable v-if="rates.length > 0" :rates="rates"></RateTable>
            <div v-else>
                <span class="text-muted">{{ $t('views.rates.not_found') }}</span>
            </div>
        </div>
        <AddRateModal v-show="addRateModalVisible" :visible="addRateModalVisible" @close-rate-modal="addRateModalVisible=false"></AddRateModal>
        <SpinnerLoader v-show="loading"></SpinnerLoader>
    </ContainerWithMenu>
</template>

<script>
    import ContainerWithMenu from "../components/container/ContainerWithMenu";
    import RateTable from "../components/rate/RateTable";
    import {LIMIT_RECORDS_API} from "../common/constants";
    import {Utils} from "../common/utils";
    import {getRates} from "../api";
    import SpinnerLoader from "../components/common/SpinnerLoader";
    import AddRateModal from "../components/modal/AddRateModal";
    import Pagination from "../components/common/Pagination";
    import i18n from '../i18n'

    export default {
        title: i18n.t('views.rates.title'),
        name: "Rates",
        components: { ContainerWithMenu, Pagination, RateTable, SpinnerLoader, AddRateModal },
        data: () => {
            return {
                rates: [],
                countRates: 0,
                limitRates: LIMIT_RECORDS_API,
                currentPageRate: 1,
                loading: false,
                addRateModalVisible: false
            }
        },
        methods: {
            async getRates(page = 1) {
                this.loading = true;
                try {
                    let ratesResponse = await getRates(page);
                    this.countRates = ratesResponse.count;

                    this.saveRatesWithSeparator(ratesResponse);
                    this.loading = false;
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            saveRatesWithSeparator(ratesResponse) {
                const rates = ratesResponse.results;
                let ratesWithSeparators = [];
                for (let i = 0; i < rates.length; i++) {
                    if (i === 0) {
                        ratesWithSeparators.push({ separator: true, separator_name: Utils.getStringRateType(rates[i].type).toUpperCase()});
                    } else if (rates[i].type !== rates[i-1].type) {
                        ratesWithSeparators.push({ separator: true, separator_name: Utils.getStringRateType(rates[i].type).toUpperCase()});
                    }
                    ratesWithSeparators.push(rates[i])

                }
                this.rates = ratesWithSeparators;
            },
            showAddRateModal() {
                this.addRateModalVisible = true;
            },
            paginateCallback(pageNum) {
                this.getRates(pageNum)
            }
        },
        computed: {
            numberPagesRates: function () {
                return Utils.getNumberPageByCountLimit(this.countRates, this.limitRates);
            }
        },
        mounted() {
            this.getRates()
        }
    };
</script>
